import { postUserOperationUserBehavior } from '../entities/user_operation';
import { isCN, isPrivate } from './config';
import { COOKIE_KEY, getCookie, setCookie } from './cookie';
import { getFingerprint } from './fingerprint';
import { isMobile } from './is';
import { sessionGetItem } from './webStorage';

export const SESSION_QUERY_PASSTHROUGH = 'session_query_passthrough';
export const INVITE_CODE = 'invite_code'; // 邀请码
export const SESSION_SOURCE = 'session_source';
export const SESSION_REF = 'session_ref';

export function getChannel() {
  const url = new URL(location.href);
  const session_pass_through = sessionGetItem(SESSION_QUERY_PASSTHROUGH) || {};
  const channel = Object.fromEntries(url.searchParams.entries());

  const link_code = sessionGetItem(INVITE_CODE) || undefined; // 邀请码注册
  const source =
    session_pass_through?.from || channel?.from || sessionGetItem(SESSION_SOURCE) || undefined; // 第三方来源注册
  const utm_source = session_pass_through?.utm_source || channel?.utm_source;
  const utm_medium = session_pass_through?.utm_medium || channel?.utm_medium;
  const utm_campaign = session_pass_through?.utm_campaign || channel?.utm_campaign;
  const utm_content = session_pass_through?.utm_content || channel?.utm_content;
  const utm_term =
    session_pass_through?.utm_term || channel?.utm_term || sessionGetItem(SESSION_REF);
  const keyword_search = session_pass_through?.keyword_search || channel?.keyword_search;
  const gclid =
    channel?.gclid ||
    channel?.qhclickid ||
    channel?.bd_vid ||
    channel?.msclkid ||
    session_pass_through?.gclid ||
    session_pass_through?.qhclickid ||
    session_pass_through?.bd_vid ||
    session_pass_through?.msclkid;

  return {
    source,
    link_code,
    utm_source,
    utm_medium,
    utm_campaign,
    utm_content,
    utm_term,
    keyword_search,
    gclid,
  };
}

export enum UNIQ_BEHAVIOR {
  SHOW_SUBSCRIBE = '/subscribe/show', // 被动触发的订阅页面展示
  CLICK_SUBSCRIBE = '/subscribe/click', // 主动触发的订阅页面
  ENTER_WORKSPACE = '/workspace', // 进入工作空间
  CLICK_ACCEPT = '/subscribe/click_accept', // 点击二维码内的确认按钮
  CLICK_AGREEMENT = '/subscribe/click_agreement', // 点击协议内的 checkbox
  CLICK_EDITOR_CHAR = '/editor/char', // 点击进入造人编辑器
  VIDEO_DOWNLOAD = '/video/download', // 点击：成片单个下载
  VIDEO_DOWNLOAD_BATCH = '/video/batchdownload', // 点击：成片批量下载
  WORKSPACE_KNOWLEDGE_ELICITATION = '/workspace/knowledge-elicitation', // 曝光：知识创作台页面
  WORKSPACE_KNOWLEDGE_ELICITATION_ASK = '/workspace/knowledge-elicitation-ask', // 点击：知识创作台-知识问答
  WORKSPACE_KNOWLEDGE_ELICITATION_GRAPH = '/workspace/knowledge-elicitation-Graph', // 曝光：知识创作台-知识图谱页面
  WORKSPACE_KNOWLEDGE_ELICITATION_AIPPT = '/workspace/knowledge-elicitation-AIPPT', // 点击：知识创作台-AIPPT按钮
  WORKSPACE_KNOWLEDGE_ELICITATION_AVATARVIDEO = '/workspace/knowledge-elicitation-avatarvideo', // 点击：知识创作台-数字人视频按钮
  WORKSPACE_KNOWLEDGE_ELICITATION_PPT_SPEAK = '/workspace/knowledge-elicitation-PPTSpeak', // 点击：知识创作台-PPTSpeak按钮
  WORKSPACE_KNOWLEDGE_ELICITATION_MIND_MAP = '/workspace/knowledge-elicitation-MindMap', // 点击：知识创作台-思维导图按钮
}

export interface UserLocation {
  city: string;
  country: string;
  countryCode: string;
  isp: string;
  lat: number;
  lon: number;
  org: string;
  query: string;
  region: string;
  regionName: string;
  status: string;
  timezone: string;
  zip: string;
}

export const getLocation = async () => {
  if (isPrivate())
    return {
      country: 'unknown',
      countryCode: 'unknown',
      city: 'unknown',
      region: 'unknown',
      lat: 0,
      lon: 0,
      isp: 'unknown',
      org: 'unknown',
    };

  try {
    const link = isCN()
      ? 'https://pro.ip-api.com/json/?key=yGUU31k9zEdRYqc'
      : 'https://pro.ip-api.com/json/?key=7LkzfXkyBnluc10';
    return (await fetch(link).then(res => res.json())) as UserLocation;
  } catch (err) {
    return {
      country: 'unknown',
      countryCode: 'unknown',
      city: 'unknown',
      region: 'unknown',
      lat: 0,
      lon: 0,
      isp: 'unknown',
      org: 'unknown',
    };
  }
};

// BI 埋点
let persistCountry: string | undefined;
export async function trackUserBehavior(
  behavior: string | UNIQ_BEHAVIOR,
  params?: Record<string, any>,
) {
  if (import.meta.server) return;

  // 同步埋点数据到bi所需随机用户id
  if (!getCookie(COOKIE_KEY.USER_RANDOM_ID)) {
    const fingerprint = await getFingerprint();
    setCookie(COOKIE_KEY.USER_RANDOM_ID, fingerprint);
  }

  const session_id = getCookie(COOKIE_KEY.USER_RANDOM_ID);
  const country = persistCountry || (await getLocation()).country;
  const {
    source,
    utm_source,
    utm_medium,
    utm_campaign,
    utm_term,
    utm_content,
    keyword_search,
    gclid,
  } = getChannel();

  postUserOperationUserBehavior({
    behavior,
    ...params,
    utm_source,
    utm_medium,
    utm_campaign,
    utm_term,
    utm_content,
    session_id,
    refer: window.document.referrer,
    country,
    keyword_search,
    gclid,
    source,
    platform: isMobile() ? 'mobile' : 'pc',
  });
}
